common:
  comments:
    allComments: 全部评论（{total}）
    author: 作者
    createSuccess: 发送成功
    delete: 删除
    deleteSuccess: 删除成功
    headFor: 请前往 {action} 即可发表您的看法…
    hottest: 最热
    latest: 最新
    login: 登录/注册
    removeConfirm: 确认要删除这条评论吗？
    reply: 回复
    replySuccess: 回复成功
    send: 发送
    support: 点赞
    supportSuccess: 操作成功
    tips: 请分享您的见解，提问或参与讨论！
    viewAllReply: 查看全部 {total} 条回复
  communityCard:
    popup:
      cancel: 稍后提醒
      invite: 邀请您加入社区
      join: 立即加入
      view: 前往查看
  header:
    login: 登录
    nav1: 首页
    nav2: 推荐
    new:
      menu1: 社区中心
      menu2: 添加仓库
      menu4: 添加组织
      menu5: 写文章
    notice:
      tooltip: 跳转到 AtomGit 消息中心
    register: 注册
    search:
      tooltip: 搜索
    user:
      menu1: 我的主页
      menu10: 退出登录
      menu2: 我的代码库
      menu3: 我的组织
      menu4: 我的变更请求
      menu5: 我的 Issues
      menu6: 我的 Starred
      menu7: 个人中心
      menu8: 社区设置
      menu9: 帮助文档
  languageName: 中文
  platform:
    name: 来源平台：{platform}
  prismjs:
    copy: 复制
    copyError: 复制失败
    copySuccess: 已复制
  search:
    hotTag:
      title: 热门标签
    index:
      nodata: 暂无数据
      title: 搜索结果
    inputPlaceholder: 您正在搜索什么…？
    journalism:
      title: 资讯
    order:
      fork: Fork 数
      hottest: 最热优先
      member: 成员数量
      newest: 最新优先
      star: Star 数
    organization:
      title: 组织
    repository:
      title: 仓库
      update: 更新
    searchResult: '{total} 条搜索结果'
    tag:
      number1: '{total} 资讯'
      number2: '{total} 仓库'
      number3: '{total} 组织'
      title: 标签
  searchDialog:
    clear: 清空
    content: 搜索内容
    history: 搜索记录
    inputPlaceholder: 您正在搜索什么…？
    searchType1: 资讯
    searchType2: 仓库
    searchType3: 组织
    searchType4: 标签
  tag:
    index:
      title: 标签
    journalism:
      title: 资讯
    organization:
      title: 组织
    repository:
      title: 仓库
  websiteDescription:
    default: 描述
  websiteKeywords:
    default: 关键词
  websiteTitle:
    default: 开放原子开源基金会
home:
  '404':
    goBack: 返回首页
    notFound: 页面未找到
  column:
    index:
      infoTotal: '文章数: {total}'
      like: '文章点赞量: {total}'
      title: 专栏
      view: '文章阅读量: {total}'
  common:
    all: 全部
    carousel:
      changeTo: 切换到图片 {index}
      jumpToUrl: 跳转到 {url}
    emptyContent: 暂无内容
    follow:
      cancel: 取消关注
      ok: 关注
    prime: 精选
  component:
    noticeBar:
      close: 关闭
    pagination:
      goto: 到第{component}页
      ok: 确定
    popconfirm:
      cancel: 取消
      ok: 确认
  content:
    title1: 推荐
    title2: 最新
    title3: 仓库
    title4: 组织
    title5: 资讯
  explore:
    author:
      button1: 关注
      button2: 已关注
      button3: 私信
      inputPlaceholder: 文明发言
      messageError: 发送失败
      messageSuccess: 发送成功
      number1: 文章
      number2: 关注
      number3: 粉丝
      sendButton1: 发送
      sendButton2: 取消
      sendMessage: 发送私信
    comments:
      allComments: 全部评论（{total}）
      author: 作者
      createSuccess: 发送成功
      delete: 删除
      deleteSuccess: 删除成功
      headFor: 请前往 {action} 即可发表您的看法…
      hottest: 最热
      latest: 最新
      login: 登录/注册
      removeConfirm: 确认要删除这条评论吗？
      reply: 回复
      replySuccess: 回复成功
      send: 发送
      support: 点赞
      supportSuccess: 操作成功
      tips: 请分享您的见解，提问或参与讨论！
      viewAllReply: 查看全部 {total} 条回复
    developer:
      empty: 暂无开发者简介
      title: 开发者
    journalism:
      comment: 评论
      copyRight1: 文章版权声明：本文由［{name}］原创发布，版权所有。
      copyRight2: 未经书面授权，禁止任何单位及个人以任何方式进行转载、摘编、复制或建立镜像。违反上述声明者，将依法追究其相关法律责任。
      favorite: '{total} 收藏'
      like: '{total} 点赞'
      preview: 【预览】
      previewTitle: 预览资讯
      public: '{date} 发布'
      read: '{view} 次阅读'
      sidePanel:
        favorite: 收藏
        like: 点赞
      title: 资讯
      view: '{total} 浏览'
    organization:
      empty: 暂无组织简介
      title: 组织
    repository:
      empty: 暂无仓库简介
      title: 仓库
    template3:
      journalism:
        collect: '{favorites} 收藏'
        like: '{like} 点赞'
        read: '{view} 阅读'
  footer:
    content: ©{year} 开放原子开源基金会 版权所有  京ICP备2020036654号-4  京公网安备 11030102011541号
  home:
    column:
      title: 推荐专栏
    communityCard:
      join: 加入社区
      joined: 已加入
      people: 成员
    communityData:
      organization:
        title: 组织
        total: 社区组织数量
      people:
        title: 成员
        total: 社区成员数量
      repository:
        title: 仓库
        total: 社区仓库数量
    datacard:
      fork: 累计 Fork 数
      pr: 累计 PR 数
      repos: 收录仓库数
      stars: 累计 Star 数
      title: 社区成就
    developer:
      more: 更多开发者
      title: 热门开发者
    event:
      detail: 了解详情
      status1: 进行中
      status2: 未开始
      status3: 已结束
      time: 长期活动
      title: 精彩活动日历
    footer:
      content: ©{year} 开放原子开源基金会 版权所有  京ICP备2020036654号-4  京公网安备 11030102011541号
      subscription:
        field1:
          error: 请输入姓名
          title: 姓名
        field2:
          error: 请输入正确的邮箱
          title: 邮箱
        subscribe: 立即订阅
        success:
          content: 感谢您关注我们！您已被添加至订阅者列表中。
          title: 订阅成功
        title: 订阅我们以获得独家新闻和活动
    organization:
      more: 更多组织
      title: 热门组织
    recommend:
      organization:
        empty: 暂无组织简介
      repository:
        empty: 暂无仓库简介
    repository:
      more: 更多仓库
      title: 热门仓库
    sidebar:
      email: 邮箱联系
      feedback: 反馈
      link: 联系
      tel: 电话咨询
      wechat: 微信扫码关注
    template3:
      footer:
        title1: 帮助文档
        title2: 隐私政策
        title3: 使用条款
      home: 查看主页
      login: 前往登录
      notice1: 早上好！
      notice2: 中午好
      notice3: 下午好！
      notice4: 晚上好！
      prime: 精
      type1: 资讯
      type2: 组织
      type3: 仓库
      welcome: 欢迎来到 {communityName}
  hot:
    follow: 关注
    followed: 已关注
    title1: 优秀开发者
    title2: 热门仓库
    title3: 精选组织
    title4: 推荐专栏
    title5: 精选资讯
  search:
    hotTag:
      title: 热门标签
    index:
      title: 搜索结果
    inputPlaceholder: 您正在搜索什么…？
    journalism:
      title: 资讯
    order:
      fork: Fork 数
      hottest: 最热优先
      member: 成员数量
      newest: 最新优先
      star: Star 数
    organization:
      title: 组织
    repository:
      title: 仓库
    searchResult: '{total} 条搜索结果'
    tag:
      number1: '{total} 资讯'
      number2: '{total} 仓库'
      number3: '{total} 组织'
      title: 标签
  subscription:
    subscribe:
      success:
        title: 订阅成功
    unsubscribe:
      button: 取消订阅
      content: 将 {email} 从订阅列表移除，您将不再收到来自 {title} 的信息。您可以随时重新订阅或使用其它邮箱地址订阅我们。
      resubscribe: 重新订阅
      success:
        content: >-
          我们很遗憾您决定取消订阅，但我们感谢您一直以来的支持。我们致力于为用户提供优质的内容，但我们也理解您的需求和选择。如果您日后需要，可以随时
          {resubscribe} 我们的服务。
        title: 退订成功
      thanks: 感谢您的理解和支持！
      title: 取消订阅
  tag:
    index:
      title: 标签
    journalism:
      title: 资讯
    organization:
      title: 组织
    repository:
      title: 仓库
  websiteDescription:
    default: 描述
  websiteKeywords:
    default: 关键词
mobile:
  '404':
    goBack: 返回首页
    notFound: 页面未找到
  column:
    all: 查看全部
    index:
      infoTotal: '文章数: {total}'
      like: '文章点赞量: {total}'
      title: 专栏
      view: '文章阅读量: {total}'
    title: 推荐专栏
  common:
    all: 全部
    carousel:
      changeTo: 切换到图片 {index}
      jumpToUrl: 跳转到 {url}
    emptyContent: 暂无内容
    follow:
      cancel: 取消关注
      ok: 关注
    nodata: '—— 暂无更多内容 —— '
    prime: 精选
  component:
    noticeBar:
      close: 关闭
    pagination:
      goto: 到第{component}页
      ok: 确定
    popconfirm:
      cancel: 取消
      ok: 确认
  content:
    title1: 推荐
    title2: 资讯
    title3: 组织
    title4: 仓库
    title5: 开发者
  footer:
    content: ©{year} 开放原子开源基金会 版权所有  京ICP备2020036654号-4  京公网安备 11030102011541号
  home:
    communityCard:
      join: 加入社区
      joined: 已加入
    detail:
      collect: 收藏
      comment: 评论
      like: 赞 {like}
      read: '{view} 次阅读'
    event:
      title: 精彩活动
    footer:
      contact: 联系我们
      content: ©{year} 开放原子开源基金会 版权所有  京ICP备2020036654号-4  京公网安备 11030102011541号
      help: 帮助
      title1: 帮助文档
      title2: 隐私政策
      title3: 使用条款
    join:
      join: 立即加入
      title: 社区
    journalism:
      collect: '{collect} 收藏'
      like: '{like} 点赞'
      read: '{view} 阅读'
    recommend:
      developer:
        empty: 暂无开发者简介
      operation:
        title: 广告
      organization:
        empty: 暂无组织简介
      repository:
        empty: 暂无仓库简介
    shareCard:
      copy: 复制链接
      copyed: 已复制
      save: 保存图片
      text1: 更多{0}都在这里
      text2: 快来
      text3: 「精彩内容」
      text4: 扫描二维码分享
      text5: 探索社区
      text6: 一切为了开发者
      title: 分享社区
  hot:
    follow: 关注
    followed: 已关注
    title1: 优秀开发者
    title2: 热门仓库
    title3: 精选组织
  search:
    index:
      title: 搜索结果
  websiteDescription:
    default: 描述
  websiteKeywords:
    default: 关键词
settings:
  '404':
    goBack: 返回首页
    notFound: 页面未找到
  action:
    add: 新建
    add1: 添加
    addJournalism: 写文章
    close: 关闭
    column1: 操作
    delete: 删除
    downline: 下线
    edit: 编辑
    editlimits: 编辑权限
    goBack: 返回
    look: 查看
    manage: 管理
    pinned: 精选
    preview: 预览
    publish: 发布
    search: 查询
    submit: 提交
    unpinned: 取消精选
    view: 查看
  component:
    dialog:
      button:
        cancel: 取消
        close: 关闭
        ok: 确认
      defaultTitle: 对话框
      error: 加载出错
      loading: 正在加载...
      refresh: 刷新页面
    markdownEditor:
      toolbar:
        fullscreen: 全屏
    richEditor:
      loading: 请稍候...
      plugins:
        markdownIt:
          title: 插入 Markdown 内容
    searchTable:
      buttonText: 查询
      subTitle: 查询条件
    upload:
      button: 点击上传
  customContent:
    index:
      description: 您编辑的自定义内容将会在首页对应区域内展示，目前仅法律模板支持展示自定义内容。
      form:
        label: 内容
      switchButton:
        markdownEditor: Markdown编辑器
        richEditor: 富文本编辑器
        switchTo: 切换为{editorType}
    switchEditor:
      cancel: 取消
      content: 确定要切换编辑器吗？切换后将清空当前内容。
      contentWithText: 检测到当前有内容，切换编辑器将清空所有内容，确定要继续吗？
      ok: 确定
      title: 切换编辑器
  directive:
    confirm:
      modal:
        button:
          cancel: 取消
          ok: 确认
        content: 确认执行这个操作吗？
        title: 操作确认
  form:
    validation:
      email: 此项不是合法的邮箱地址
  menu:
    direction:
      column:
        detail:
          index: 专栏详情
        index:
          add: 新增专栏
          edit: 修改专栏
        listing:
          index: 专栏管理
      comment:
        index: 评论管理
      journalism:
        add: 新增资讯
        edit: 修改资讯
        index: 资讯管理
      organization:
        add: 新增组织
        application: 组织申请列表
        index: 组织管理
      repository:
        add: 新增仓库
        application: 仓库申请列表
        index: 仓库管理
        listing: 仓库列表
      tag:
        add: 新增标签
        edit: 修改标签
        index: 标签管理
      title: 内容管理
    home:
      title: 首页
    operator:
      activityApplication:
        add: 新增申请
        edit: 修改申请
        index: 活动申请
      banner:
        add: 新增 Banner
        edit: 修改 Banner
        index: Banner 位
      communityInfo: 社区信息
      customContent:
        index: 自定义内容
      email:
        add: 新增模板
        edit: 修改模板
        index: 邮件模板
      event:
        add: 新增活动
        edit: 修改活动
        index: 活动日历
      notice:
        index: 社区公告
      operator:
        add: 新增运营活动
        edit: 修改运营活动
        index: 运营活动
      popupWindow:
        index: 自定义弹窗
      seo:
        edit: SEO 设置
      stats:
        index: 统计设置
      subscribe:
        history: 发送历史
        index: 订阅列表
      title: 社区运营
      token:
        add: 新建访问令牌
        index: 访问令牌
      toolbar:
        index: 导航栏
    system:
      floatNavigation:
        index: 浮动导航
      homepage:
        index: 首页设置
      people:
        index: 成员管理
      title: 社区管理
  notification:
    del: 删除成功
    fileLarge: 文件太大，请选择小于 {size} 的文件
    networkError: '网络请求出错! API: {url} ; 错误信息: {msg}'
    notice1: 请至少选择一个用户
    notice2: 加入邮件发送队列成功
    required: 此项必填
    requiredSelect: 此项必选
    success: 操作成功
    upload:
      error: 上传失败！
      filenameError: 上传文件名获取错误！
      illegal: 无权上传文件！
      networkError: '网络错误: {msg}'
      otherError: '图片上传错误: {msg}'
      success: 上传成功！
    uploadRequired: 此项必传
  table:
    column:
      action: 操作
  token:
    column1: 令牌名称
    column2: 令牌详情
    column3: 到期时间
    column4: 创建时间
    column5: 到期时间
    column6: 到期时间
    date: '{day}天'
    desc: 生成令牌用于访问
    expired1: 已过期
    expired2: 将于 {day} 天后过期
    expired3: 将于 {month} 个月后过期
    expired4: 将于 {year} 年后过期
    pop:
      desc: '*访问令牌创建成功后仅可见一次，请及时复制保存。'
      title: 访问令牌创建成功
  view:
    activityApplication:
      edit:
        column1: 申请人
        column10: 类型
        column11: 技术领域
        column12: 赛题名
        column13: 赛题描述
        column14: 历史经验
        column15: 获得的支持
        column2: 联系方式
        column3: 邮箱
        column4: 地址
        column5: 单位
        column6: 职业
        column7: 微信号
        column8: 学校
        column9: 平台
      index:
        column1: 申请人
        column10: 操作
        column2: 联系方式
        column3: 邮箱
        column4: 地址
        column5: 单位
        column6: 职业
        column7: 微信号
        column8: 学校
        column9: 平台
        header1: 关键词
        status:
          '0': 未审核
          '1': 审核通过
          '2': 审核不通过
          all: 全部
        statusSelect: 状态
      platformOptions:
        campus: 校源行
        competition: 大赛
      statusOptions:
        approved: 已通过
        pending: 待审核
        rejected: 已拒绝
      typeOptions:
        competition: 赛题
    banner:
      index:
        column1: 名称
        column3: 图片
    column:
      detail:
        add:
          column1: 选择资讯
          placeholder1: 选择/搜索
          title: 添加资讯
        index:
          author: 作者
          collection: 收藏量
          column: 标题
          introduce: 简介
          like: 点赞量
          time: 发布时间
          view: 浏览量
      listing:
        add:
          colum1: 名称
          colum2: 描述
          colum3: 封面
          colum4: 展示顺序
          colum5: 移动端封面
          tips1: 请上传图片尺寸为 xxx 的图片
        index:
          column: 专栏名称
          cover: 封面
          operate: 操作
          order: 顺序
          quantity: 资讯数量
          state: 状态
          status:
            '0': 全部
            '1': 已发布
            '2': 已下线
          time: 创建时间
    comment:
      index:
        comments: 评论内容
        del: 删除
        hide: 隐藏
        notification:
          del: 删除成功
          success: 操作成功
        operate: 操作
        reviewArticle: 评论文章
        show: 展示
        time: 评论时间
        title: 文章标题
        user: 评论人
    event:
      edit:
        button: 按钮默认文本为“了解详情”
        colum1: 标题
        colum10: ' 活动描述'
        colum2: 样式
        colum3: 活动图片
        colum4: 按钮文本
        colum5: 跳转链接
        colum6: 顺序
        colum7: 类型
        colum8: 时间
        colum9: 活动地点
        help: '图片尺寸: 240x144 像素'
        notice: 此处将展示您配置的活动标题。
        type1: 模板
        type2: 自定义
    floatNavigation:
      edit:
        title1: 联系电话
        title2: 邮箱
        title3: 意见反馈
        title4: 公众号
      index:
        column1: 图标
        column2: 信息类别
        column3: 展示内容
        column4: 跳转链接
        column5: 展示状态
        column6: 操作
    general:
      add: 新增
      addFooter:
        column1: 内容
      addMedium:
        column1: 名称
        column2: URL
        column3: 图片图标
      addfooter: 新增 Footer 内容
      addmedium: 新增媒体
      column1: 社区名称
      column2: 社区描述
      column4: 社区主 LOGO
      column5: 社区小 LOGO
      column6: 微信公众号
      column7: 媒体信息
      editfooter: 编辑 Footer 内容
      editmedium: 编辑媒体
      help4: '图片尺寸: 280x72 像素'
      help5: '图片尺寸: 128x128 像素'
      help6: 请上传微信公众号的二维码
    homepage:
      column1: Banner
      column10: 热门
      column11: 专栏
      column12: 资讯
      column13: 日历活动
      column14: 精选资讯
      column15: 自定义内容
      column16: 热门标签
      column17: 社区成就
      column2: 精选内容
      column3: 社区数据
      column4: 运营活动
      column5: 热门仓库
      column6: 热门组织
      column7: 热门开发者
      column8: 推荐内容
      column9: 社区卡片
      edit: 修改
      module: （当前模版）
      templateAlert: 注意：模版的开关需要点击"使用"或"修改"后才会生效，点击"使用"或"修改"后，其他模版的开关状态会恢复成默认状态。
      use: 使用
    journalism:
      add:
        column1: 标题
        column2: 内容描述
        column3: 封面图
        column4: 标签
        column5: 正文
        column6: 关键词
        column7: 发布时间
        draft: 暂存
        help3: '图片尺寸: 864x416 像素'
        help4: 最多选择5个标签
        help6: 多个关键词用英文逗号隔开
        placeholder1: 选择/搜索
        selectColumns: 选择专栏
      index:
        action1: 退稿
        all: 全部
        column1: 标题
        column2: 标签
        column3: 封面
        column4: 更新时间
        column5: 作者
        column6: 状态
        column7: 操作
        header1: 关键词
        header2: 更新时间
        header3: 精选
        included: 收录
        includedColumns: 收录到专栏
        notpass: 不通过
        pass: 通过
        refuse: 拒绝通过
        status:
          '1': 已发布
          '2': 待审核
          '3': 已下线
          '4': 待审核
        type:
          '1': 精选
          '2': 非精选
      rejectWindow:
        column: 标题
        refuse: 原因
    notice:
      add: 新增公告
      content: 公告内容
      createTime: 创建时间
      edit: 编辑公告
      endTime: 结束时间
      jumpLink: 跳转链接
      'no': 否
      releaseTime: 发布时间
      timedRelease: 定时发布
      title: 公告标题
      validity: 有效期
      'yes': 是
    operation:
      edit:
        colum1: 标题
        colum2: 图片
        colum3: 跳转链接
        colum4: 顺序
        colum5: 活动类型
        colum6: 活动时间
        column1: ''
        column2: ''
        column3: ''
        column4: ''
        column5: ''
        column6: ''
        status:
          '1': 短期活动
          '2': 长期活动
        tips1: 为了能有更好的展示效果，建议您上传尺寸为 1920x320（有效内容为 1200 像素）的图片
        tips2: '图片尺寸: 360x180 像素'
      index:
        column1: 名称
        column2: 跳转链接
        column3: 图片
        column4: 活动时间
        column5: 顺序
        column7: 操作
        status:
          '0': 全部
          '1': 展示中
          '2': 未开始
          '3': 已失效
          '4': 长期
          '5': 已下线
    organization:
      add:
        button: 返回列表
      application:
        action:
          editLabel: 编辑标签
          notFeatured: 取消精选
          selected: 精选
          unbinding: 解绑
        agree: 同意
        all: 全部
        applicant: 申请人
        briefIntroduction: 组织简介
        column: 组织名称
        column1: Star 数量
        column2: Fork 数量
        column3: 标签
        linkTime: 关联时间
        notFeatured: 非精选
        operate: 操作
        refuse: 拒绝审批
        refuse1: 拒绝
        selected: 精选
        time: 申请时间
      dialog:
        label:
          column1: 标签
          help1: 最多选择5个标签
      index:
        add: 新增组织
        application: 申请列表
        column1: 组织名称
        column2: 简介
        column3: 仓库
        column4: ''
        listing: 组织列表
      rejectWindow:
        column: 组织名称
        refuse: 拒绝原因
    people:
      edit:
        column1: 昵称
        column2: 账号
        column3: 权限
        column4: 角色
        status:
          '1': 成员
          '2': 管理员
          '3': 常规管理员
      index:
        all: 全部
        button:
          add: 新建
        column1: 头像
        column2: 昵称
        column3: 账号
        column4: 加入日期
        column5: 权限
        column6: 操作
        header1: 关键词
        header2: 加入时间
        status:
          '1': 超级管理员
          '2': 管理员
          '3': 成员
        title1: 编辑权限
        type:
          '1': 精选
          '2': 非精选
    popupWindow:
      column1: 弹窗类型
      column2: 弹窗图片
      column3: 弹窗标题
      column4: 弹窗描述
      column5: 推广文案
      column6: 跳转链接
      help1: 为了获得更好的视觉效果，推荐上传尺寸为600*208的图片，大小不超过2M
      preview: 效果展示
      title1: 加入社区
      title2: 自定义弹窗
      title3: 关闭弹窗
    repository:
      add:
        button: 返回列表
      application:
        action:
          editLabel: 编辑标签
          notFeatured: 取消精选
          selected: 精选
          unbinding: 解绑
        agree: 同意
        all: 全部
        applicant: 申请人
        briefIntroduction: 仓库简介
        column: 仓库名称
        column1: Star 数量
        column2: Fork 数量
        column3: 标签
        linkTime: 关联时间
        notFeatured: 非精选
        operate: 操作
        refuse: 拒绝审批
        refuse1: 拒绝
        reset: 重置
        selected: 精选
        time: 申请时间
      dialog:
        label:
          column1: 标签
          help1: 最多选择5个标签
          title: 编辑标签
      index:
        add: 新增仓库
        application: 申请列表
        column1: 仓库名称
        column2: 简介
        column3: Star 数量
        column4: Fork 数量
        column5: ''
        listing: 仓库列表
      listing:
        applicant: 申请人
        briefIntroduction: 仓库简介
        column: 仓库名称
        operate: 操作
        reset: 重置
        time: 关联时间
      rejectWindow:
        column: 仓库名称
        refuse: 拒绝原因
    seo:
      description: 描述
      keywords: 关键词
      keywordsHelp: 多个关键词用英文逗号隔开
      robots: robots.txt
      title: 标题栏
    stats:
      baidu:
        help:
          '1': 要获取“百度统计ID”，请参考此{component}。
          '2': “百度统计ID”是一个由 32 位数字和字母组合而成的字符串，例如“3388ff634a74c1cd4fd62172cddf2b2d”。
          '3': 文档
        id: 百度统计ID
    subscription:
      template:
        edit:
          button: 返回列表
          help: Markdown 格式
        index:
          column1: 模板名称
          column2: 创建人
          column3: 邮件标题
          column4: 创建时间
          column5: 操作
          column6: 邮件内容
      user:
        history:
          action: 收件人
          button1: 刷新
          column1: 邮件标题
          column2: 发送时间
          column3: 操作人
          column4: 操作
        index:
          button1: 发送邮件
          button2: 发送历史
          column1: 搜索
          column2: 订阅时间
          column3: 用户姓名
          column4: 用户邮箱
          column5: 操作
          condition1: 当前选中用户
          condition2: 当前条件下所有用户
        listing:
          title: 收件人
        preview:
          button: 关闭
          title: 预览邮件
        template:
          column1: 模板名称
          column2: 邮件标题
          notice1: 请选择一个模版
          status1: 确认
          status2: 取消
          title: 选择模板
        view:
          title: 查看用户
        window:
          column1: 用户名称
          column2: 邮箱
          notice: 邮件发送后将无法撤回，请再次确认相关信息是否正确！
          status1: 确认
          status2: 取消
          title: 发送确认
    tag:
      index:
        button:
          add: 新建
        column1: 标签名称
        column2: 排序
        column3: 展示状态
        column4: 创建时间
        column5: 操作
        header2: 发布时间
        title1: 新增标签
        title2: 编辑标签
    toolbar:
      index:
        action1: 添加子导航
        column1: 标题
        column2: 链接
        column3: 顺序
        column4: 操作
        column5: 英文标题
        column6: 类型
        column7: 标签/专栏名称
        column8: 英文标题
        header1: 标题
        title1: 新增导航栏
        title2: 编辑导航栏
        type1: 链接
        type2: 标签
        type3: 专栏
        type4: 父导航
    welcome:
      data:
        count: 个
        members: 用户数量
        organization: 组织数量
        repository: 仓库数量
      general:
        column1: 访问数(PV)
        column2: 访客数(UV)
        column3: 新增用户
        column4: 活跃用户
        column5: 新增代码库
        column6: 新增组织
        column7: 新增提交
        column8: 新增 Issue
        column9: 新增变更请求
        title: 核心指标
      overview:
        organization: 新增组织
        pv: 访问量(PV)
        repository: 新增代码库
        title: 今日概况
        user: 活跃用户
      save: 保存为图片
      welcome: 欢迎访问社区控制台！
  websiteTitle:
    default: 社区设置
